import React, { Component } from 'react';
import Input from '../../components/UI/Input/Input';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import classes from './../../index.css';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import axios from '../../axios-ns';
import Aux from '../../hoc/Aux';
import * as messages from '../../messages';
import OptIn from '../OptIn/OptIn';

const surveyCode = 'survey_001';

class Survey extends Component {
    state = {
        randomImages: [
            'http://nauka-spiewu.pl/assets/images/cartoon/1survey.JPG',
            'http://nauka-spiewu.pl/assets/images/cartoon/2survey.JPG',
            'http://nauka-spiewu.pl/assets/images/cartoon/3survey.JPG',
            'http://nauka-spiewu.pl/assets/images/cartoon/4survey.JPG',
            'http://nauka-spiewu.pl/assets/images/cartoon/5survey.JPG',
            'http://nauka-spiewu.pl/assets/images/cartoon/6survey.JPG',
            'http://nauka-spiewu.pl/assets/images/cartoon/7survey.JPG',
            'http://nauka-spiewu.pl/assets/images/cartoon/8survey.JPG'
        ],
        error: null,
        loading: false,
        question: {
            surveyCode: '',
            code: '',
            question: '',
            type: '',
            userToken: '',
            answers: []
        },
        value: '',
        error: '',
        imageIndex: 0,
        questionNumber: 1
    };

    onRegister = () => {
        //TODO: tutaj jakiś przyjemny komunikat, a w wiadomości email link bezpośrednio do weryfikacji wokalnej
        this.props.history.replace('/sps-optin-completed');
    }

    componentDidMount() {
        this.setState({ ...this.state, loading: true });

        axios.get('/surveys/' + surveyCode + '/start')
            .then(response => {
                let question = response.data;

                if (question.code == null) {
                    this.setState({ ...this.state, loading: false, surveyFinished: true });
                } else {
                    question['answers'] = JSON.parse(question.answers);
                    this.setState({ ...this.state, loading: false, question: question, value: '' });
                }

            })
            .catch(err => {
                this.setState({ ...this.state, loading: false, errorMessage: 'Coś poszło nie tak' });
            });
    }

    inputChangedHandler = (event) => {
        this.setState({ ...this.state, value: event.target.value });
    }

    isValid(value) {
        if (this.state.question.type == 'EMAIL' && !this.isEmail(value)) {
            return false;
        } else if (value == '') {
            return false;
        }

        return true;
    }

    isEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return re.test(String(email).toLowerCase());
    }

    submitHandler = (event) => {        
        this.setState({ ...this.state, questionNumber: ++this.state.questionNumber, loading: true, error: null, imageIndex: Math.floor(Math.random() * (this.state.randomImages.length - 1)) });
        event.preventDefault();

        if (!this.isValid(this.state.value)) {
            this.setState({ ...this.state, loading: false, error: true });
            return;
        } else {
            axios.post('surveys/' + this.state.question.surveyCode + '/question/' + this.state.question.code + '/save', { userToken: this.state.question.userToken, value: this.state.value })
                .then(response => {
                    let question = response.data;
                    
                    if(question.answers) {
                        question['answers'] = JSON.parse(question.answers);
                    }

                    this.setState({ ...this.state, loading: false, question: question, value: ''});
                })
                .catch(err => {
                    this.setState({ ...this.state, loading: false, errorMessage: 'Coś poszło nie tak' });
                });

        }
    }

    render() {
        let res = null;

        if(this.state.loading) {
            res = <Spinner/>
        } else if (!this.state.question.code) {
            // let path = "http://localhost:3000/vocaldemy/front/signup?token=" + this.state.question.userToken;
            res = <p style={{padding: '10px', marginTop: '150px'}}>Świetnie!<br/><br/>Teraz znam znacznie lepiej Twoje oczekiwania odnośnie nauki śpiewu.<br/><br/>Na spokojnie przeanalizuję te informacje. Ty w międzyczasie wykonaj proszę darmową weryfikacja wokalną.<br/><br/>Aby do niej przystąpić, proszę zarejestruj się na platformie Vocaldemy a już za chwilę otrzymasz zestaw ćwiczeń weryfikacyjnych, które pozwolą ocenić mi poziom Twojego wokalu.<br/><br/>            
                    <OptIn header="Weryfikacja wokalna" productCode="SPS" userToken={this.state.question.userToken} buttonLbl="Rozpocznij weryfikację wokalną" onSuccess={() => this.onRegister()} />            
                </p>
        } else {
            let control = null;

            if(this.state.question.type === 'SELECT') {
                let answers = this.state.question.answers.map(a => <MenuItem key={a.key} value={a.key}>{a.value}</MenuItem>);

                control = <Select
                value={this.state.value}
                onChange={(event) => this.inputChangedHandler(event)}
            >
                {answers}
            </Select>
            } else if (this.state.question.type === 'TEXT') {
                control = <TextField
                id="outlined-multiline-flexible"
                multiline
                rowsMax="4"
                value={this.state.value}
                onChange={(event) => this.inputChangedHandler(event)}
                margin="normal"
                helperText="Opisz proszę możliwie precyzyjnie swoją odpowiedź."
            />
            }

            let error = this.state.error ? <span style={{color: 'rgb(227, 122, 62)'}}>Proszę udzielić odpowiedzi na pytanie.</span> : null;

            res = (<Aux>
                {error}
                <p style={{marginTop: '10px', fontSize: '20px'}}>{this.state.question.question}</p>
                <form onSubmit={(event) => this.submitHandler(event)}>
                    {control}
                    <p style={{textAlign: 'center'}}>
                    <Button variant="contained" type="submit" color="primary" style={{backgroundColor: 'orange'}}>Dalej</Button><br/><br/>{this.state.questionNumber} / {this.state.questionNumber > 8 ? this.state.questionNumber : 8}
                    </p>
                </form>
            </Aux>);
        }

        return <Card style={{width: '500px'}}>
            <CardMedia
                        style={{float: 'left', width: '100%', height: '150px', borderBottom: '5px solid orange'}}
                        image={this.state.randomImages[this.state.imageIndex]}                        
                    />
            <div style={{padding: '10px'}}>
                {res}
            </div>
        </Card>;
    }
}

export default Survey; 